/// <reference types="vite/client" />

export async function getReleaseNotes() {
  const content = (await Promise.all(
    Object.values(import.meta.glob('./release-notes/*.md')).map((loadMarkdown) => loadMarkdown())
  )) as { attributes: { title: string; date: string }; html: string }[];

  return content.map((markdownModule) => ({
    title: markdownModule.attributes.title,
    date: markdownModule.attributes.date,
    content: markdownModule.html,
  }));
}
